import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var finYearListRes;
export const finYearListTodo = createAsyncThunk('finYearList', async () => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'hr/year_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return finYearListRes = res.data
    } catch (error) {
        return finYearListRes = error.response.data
    }
})


const finYearListSlice = createSlice({
    name: 'finYearList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(finYearListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('finYearList', state.data)
            }
        });
        builder.addCase(finYearListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default finYearListSlice.reducer; 